// extracted by mini-css-extract-plugin
export default {"required-signature":"RequiredSignature_required-signature__zUBAN","hint":"RequiredSignature_hint__tzOj5","signature":"RequiredSignature_signature__hRJkT"};